'use client';

import React from 'react';
import Fieldset from '~/components/commonUi/Fieldset';
import InnerLayout from '~/components/InnerLayout';
import ElectionMenu from '~/components/ElectionMenu';
import AddZipCodes from './AddZipCodes';
import Pagination from './Pagination';
import ListZipCodes from './ListZipCodes';
import Button from '~/components/commonUi/Button/Button';
import { XMarkIcon } from '@heroicons/react/16/solid';
import { getStore } from '~/mobx/AppStore';
import { observer } from 'mobx-react';

interface ZipcodeProps {
    isDisabled: boolean;
    zipcodeList: string[];
    isGettingZipcode: boolean;
    deleteZipcode: () => void;
}

const ZipCodes = (props: ZipcodeProps) => {
    const { electionMenuStore } = getStore();

    const renderMainContent = () => {
        const shouldRenderDeleteButton = !props.isDisabled && !props.isGettingZipcode && props.zipcodeList.length > 0;

        return (
            <Fieldset title={`${electionMenuStore.selectedElectionMenu?.text} - Postnummer`}>
                <>
                    {!props.isDisabled && (
                        <>
                            <div className="mb-4">
                                Fyll inn fra - til postnummer for å legge inn en hel serie. Fyll inn kun &quot;Fra&quot;
                                for et enkelt postnummer.
                            </div>
                            <AddZipCodes />
                        </>
                    )}
                    <form method="POST" id="delZipcodeForm" name="delZipcodeForm">
                        <Pagination />
                        <ListZipCodes />
                        <Pagination />
                        {shouldRenderDeleteButton && (
                            <Button
                                btnText={'Slett markerte'}
                                testId={'delete-btn'}
                                icon={<XMarkIcon className="size-5 text-red-700" />}
                                onClick={props.deleteZipcode}
                            />
                        )}
                    </form>
                </>
            </Fieldset>
        );
    };

    return <InnerLayout className="zip-codes-page" leftPanel={<ElectionMenu />} content={renderMainContent()} />;
};

const ZipCodeWithStore = () => {
    const { zipcodeStore, generalSettingsStore } = getStore();

    return (
        <ZipCodes
            isDisabled={generalSettingsStore.isSettingsDisabled}
            zipcodeList={zipcodeStore.zipcodeList}
            isGettingZipcode={zipcodeStore.isGettingZipcode}
            deleteZipcode={zipcodeStore.deleteZipcode}
        />
    );
};

export default observer(ZipCodeWithStore);
